<template>
	<div id="home-container" class="home">
		<satellite></satellite>
		<carousel></carousel>
		<modal-satellite></modal-satellite>
		<div class="container">
			<h2 class="title-center text-uppercase">Nuestra selección</h2>
			<h4 class="text-center empty text-uppercase" v-if="!bestProductsLimited.length">Estamos actualizando nuestros mejores productos.</h4>
			<div class="col-sm-2" :class="{ 'card-item-home': bestProductsLimited.length > 4 }" v-for="product in bestProductsLimited">
				<card :product="product"></card>
			</div>
		</div>
		<div class="container">
			<h2 class="title-center text-uppercase">Especiales</h2>
			<h4 class="text-center empty text-uppercase" v-if="!specialProductsLimited.length">Estamos actualizando nuestros productos especiales.</h4>
			<div class="col-sm-2" :class="{ 'card-item-home': specialProductsLimited.length > 4 }" v-for="product in specialProductsLimited">
				<card :product="product"></card>
			</div>
		</div>
		<div class="container">
			<h2 class="title-center text-uppercase">Novedades</h2>
			<h4 class="text-center empty text-uppercase" v-if="!newProductsLimited.length">No hay productos en la tienda.</h4>
			<div class="col-sm-2" :class="{ 'card-item-home': newProductsLimited.length > 4 }" v-for="product in newProductsLimited">
				<card :product="product"></card>
			</div>
		</div>
		<banner></banner>
		<div class="container-fluid no-padding-sides">
			<h2 class="title-center">Del taller a tu hogar</h2>
		</div>
		<carousel-about></carousel-about>
	</div>
</template>

<script>
import Satellite from '../components/Home/Satellite.vue';
import ModalSatellite from '../components/Modals/Modal-satellite.vue';
import Carousel from '../components/Home/Carousel.vue';
import Card from '../components/Home/Card.vue';
import Banner from '../components/Banner.vue';
import { router } from '../routes/routes';
import CarouselAbout from '../components/About/Carousel.vue';

export default {
	vuex: {
		getters: {
      bestProducts: state => state.featureds,
      specialProducts: state => state.specials,
      newProducts: state => state.news,
		}
	},

	computed: {
		bestProductsLimited() {
			return this.bestProducts.slice(0, 5);
		},
    specialProductsLimited() {
      return this.specialProducts.slice(0, 5);
    },
    newProductsLimited() {
      return this.newProducts.slice(0, 5);
    },
	},

	components: {
		Satellite,
		ModalSatellite,
		Carousel,
		Card,
		Banner,
		CarouselAbout,
	},

	ready () {
		/*if($(window).width < 1025){
			$(".home .col-sm-2").css("width", "25%");
		}*/
		$('.carousel').carousel()

		// Write the headers.
		document.title = 'Lasddi | Muebles de Diseño | Estilo Escandinavo'
		$('meta[name="description"]').attr('content', 'En Lasddi nos dedicamos a la fabricación de muebles de diseño estilo escandinavo (nórdico), réplicas con gran nivel de acabados y atención personalizada.')
	}
};
</script>



// WEBPACK FOOTER //
// Home.vue?2c9140ea